// ============================================================
// useGameActions
// Owns: all game lifecycle handlers.
// Receives call from useChatActions — single API entry point.
// ============================================================
export default function useGameActions({
  call, fetchAll, matchId,
  proposing, setProposing, setGameError, setActiveSection,
  proposeGame, acceptInvite, rejectInvite,
  activeGameSession, gameSessionId, exitedSessionRef,
  serverState,
}) {
  const sendGameInvite = async text => call('post', '/send/game-invite', { text });

  const proposeGameAndWait = async (gameType, label) => {
    if (proposing) return;
    setGameError('');
    setProposing(true);
    await sendGameInvite(label);
    await proposeGame({ matchId, gameType, invitedPlayer: serverState?.otherUserId });
    setProposing(false);
    await fetchAll();
  };

  const acceptAndPlay = async () => {
    if (!activeGameSession) return;
    const result = await acceptInvite(activeGameSession.id);
    if (result?.ok) {
      setActiveSection('P');
      await fetchAll();
    }
  };

  const declineGame = async messageText => {
    await sendGameInvite(messageText);
    if (activeGameSession) await rejectInvite(activeGameSession.id);
    await fetchAll();
  };

  const resetToGameSelection = () => {
    setGameError('');
    setActiveSection(null);
    // Mark session as exited so COMPLETED polling gap does not re-mount the panel
    if (gameSessionId) exitedSessionRef.current = gameSessionId;
    fetchAll();
  };

  const handleGameRestart = () => {
    setActiveSection('P');
    fetchAll();
  };

  return {
    proposeGameAndWait, acceptAndPlay, declineGame,
    resetToGameSelection, handleGameRestart,
  };
}
